module.exports = __webpack_public_path__ + "img/email.9968ac1d.svg";